import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '~/style/colors-ts';

export const drawerOverrides: Components<Theme>['MuiDrawer'] = {
    styleOverrides: {
        // Temporary (modal) drawers open above the app's header, which is pinned at `drawer + 1`
        // (DrawerTopBar) so the permanent side menu slides under it.
        modal: ({theme}) => ({
            zIndex: theme.zIndex.drawer + 2,
        }),
        paper: {
            backgroundColor: COLORS.white[900],
        },
    },
};
